<template>
  <div class="w-full">
    <div
      v-for="(banner, index) in banners"
      class="flex w-full items-center justify-center px-spacing_9 py-spacing_5"
      :key="index"
      :style="{
        backgroundColor: banner.background_color ?? '#1f2a13',
      }"
    >
      <Text
        content_type="rich"
        class="banner-content font-secondary text-size_3 font-medium leading-[100%] text-neutral-100 [&_.color]:text-[var(--color)]"
        :value="banner.content"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Text from "~/components/common/Atom/Text.vue";
import type { HomeBannerProps } from "~/types/schemas/Informative/Organism/HomeBanner";

withDefaults(defineProps<HomeBannerProps>(), {
  banners: () => [],
});
</script>
